import { isToday } from '../../utils/utils';

interface TableDateRowProps {
  date: Date;
}

function TableDateRow({ date }: TableDateRowProps) {
  const isSameToday = isToday(date);

  const formattedDate = new Intl.DateTimeFormat('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  }).format(date);

  return (
    <section className="table-date-row-section">
      <p className="b1-semibold">{isSameToday ? 'Today' : formattedDate}</p>
    </section>
  );
}

export default TableDateRow;
